/*
 * Public API Surface of ngx-switch-input
 */

export * from './ngx-switch-input.component';
export * from './ngx-switch-input.module';
